import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'

import BuilderPage from '@/pages/BuilderPage.vue'
import PreviewPage from '@/pages/PreviewPage.vue'
import { useAppStore } from '@/store/app'

interface Options {
  [key: string]: any
}

export const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: '/v2/location/:locationId/payments/proposals-estimates/templates/edit/:id',
    name: 'proposals-estimates-template-builder',
    component: BuilderPage,
    props: { isDocForm: false },
  },
  {
    path: '/v2/location/:locationId/payments/proposals-estimates/doc-form/edit/:id',
    name: 'proposals-estimates-doc-form-builder',
    component: BuilderPage,
    props: { isDocForm: true },
  },
  {
    path: '/v2/location/:locationId/payments/proposals-estimates/templates/preview/:id',
    component: PreviewPage,
    name: 'proposals-estimates-template-preview',
  },
  {
    // this route is being used in template library team (preview template)
    // path: '/template-builder-preview/v2/document-contracts/templates/view/preview/:id',
    // path: 'v2/document-contracts/templates/view/preview/:id',
    path: '/template-builder-preview/v2/preview/:id',
    component: PreviewPage,
    name: 'documents-contracts-white-label-template-preview',
  },
  // {
  //   // this route is being used in template library team (preview template)
  //   // path: '/template-builder-preview/v2/document-contracts/templates/view/preview/:id',
  //   // path: 'v2/document-contracts/templates/view/preview/:id',
  //   path: 'preview/:id',
  //   component: PreviewPage,
  //   name: 'documents-contracts-template-preview',
  // },
]

export const parentRoutes = [
  {
    path: '/v2/location/:locationId/payments/proposals-estimates',
    name: 'proposals-estimates',
  },
  {
    path: '/v2/location/:locationId/payments/proposals-estimates/templates',
    name: 'proposals-estimates-templates',
  },
  {
    path: '/v2/location/:locationId/payments/proposals-estimates/edit/:documentId',
    name: 'builder',
  },
  {
    path: '/v2/location/:locationId/payments/settings/taxes',
    name: 'payment-settings-taxes',
  },
  {
    path: '/v2/location/:location_id/payments/integrations',
    name: 'payment-integrations-v2',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const appStore = useAppStore()

  if (from.name?.toString().includes('builder') && appStore.unsavedChanges) {
    // Let the component handle the navigation with the modal
    next(false)
    return
  }

  next()
})

export function emitRouteChangeToParent(path: string, options?: Options) {
  if (!path) return
  const store = useAppStore()
  try {
    if (store.handshake && typeof store.handshake.then === 'function') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      store.handshake.then((parent: any) => {
        parent.emit('route-change', {
          router: path,
          ...options,
        })
      })
    }
  } catch (error) {
    console.error(error)
  }
}

export { router }
